import { useParams } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { PlansWorkspace } from '../components/evaluation/PlansWorkspace';

/** ADMIN-03 — one interview plan, open under the strip of plans (admin redesign batch 2, Option A). `new` starts a blank one. */
export function PlanTemplateEditorPage(): ReactNode {
  const { planId } = useParams({ from: '/app-layout/admin/interview-plans/$planId' });
  return <PlansWorkspace selectedId={planId} />;
}
